export const SHARE_TITLE = 'ATOMica';

export const SHARE_TEXT = 'ミーティングに招待されました！';

export const BOTTOM_NAGIGATOR_HEIGHT = 80;

export const SUB_BUTTON_HEIGHT = 64;

export const DISPLAY_AVATOR_COUNT = 3;
